import React from 'react'
import Icon from 'blocks.simple/icon/icon'
import { text as textStyles } from 'theme'
import { cn } from 'ethcss'
import styles from './tag.jcss'
import type { TagDefaultProps, TagProps } from './tag.types'

const Tag = (p_: TagProps) => {
    return (
        <span
            className={cn(styles.item, p_.className, p_.mod ? textStyles[p_.mod] : '', p_.systemQ ? styles.system : '')}
            onClick={p_.onClick ? p_.onClick : () => {}}
        >
            #{p_.value}
            {p_.onIconClick && (
                <span className={styles.icon}>
                    <Icon type="close" iconColor={p_.mod} size="10" onClick={p_.onIconClick} />
                </span>
            )}
        </span>
    )
}

const defaultProps: TagDefaultProps = {
    mod: 'darkCloud',
}

Tag.defaultProps = defaultProps

export default Tag
